import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { MetaData } from 'components/MetaData'
import { EmptyContainer, FadeIn, Spinner } from 'lib/ui/components'
import { NoMatch } from 'lib/shared/scenes/NoMatch'
import { fetchPostsByTag } from 'lib/core/data/blog/postsByTag'
import { getPostByTag } from 'lib/core/data/blog/postsByTag/selectors'
import { getPostBySlugs } from 'lib/core/data/blog/post/selectors'
import { MainTitle } from '../../components/MainTitle'
import { NoPosts } from '../../components/NoPosts'
import { PostsGrid } from '../../components/PostsGrid'

export const Tag = () => {
  const params = useParams<{ slug: string }>()
  const slug = params.slug
  const dispatch = useDispatch()
  const postByTag = useSelector(getPostByTag(slug))
  const { isFirstLoad, postSlugs } = postByTag ?? {}
  const posts = useSelector(getPostBySlugs(postSlugs))
  const title = `#${slug}`

  useEffect(() => {
    dispatch(fetchPostsByTag(slug))
  }, [
    slug,
    dispatch
  ])

  if (!postByTag) {
    return (
      <NoMatch />
    )
  }

  return (
    <>
      <MetaData
        title={title}
      />
      <FadeIn
        key={`title-${slug}`}
      >
        <MainTitle
          title={title}
        />
      </FadeIn>

      {isFirstLoad ? (
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      ) : (
        <FadeIn
          key={`content-${slug}`}
        >
          {postSlugs?.length ? (
            <>
              <PostsGrid
                title={`All ${title} Articles`}
                posts={posts}
                isTag
              />
            </>
          ) : (
            <NoPosts />
          )}
        </FadeIn>
      )}
    </>
  )
}
